<template>
<div v-bind:class="{collapsible : collapsible}" class="card-1" :href="url" >
    <div class="d-flex flex-row h-100">
        <div class="name d-flex">
            <div class="m-auto font">{{text}}</div>
            </div>
    <div class="distance d-flex"> 
        <div class="m-auto font" style="color:white">{{distance}}</div>
        </div>
    </div>
    <div class="content">
        {{content_coll}}
    </div>
</div>
    
</template>


<script>
export default {
    name: "Card",
    props: {text: String,
            distance: String,
            collapsible : Boolean,
            content_coll: String,
            url: String,
            
            },
    
   

      
    
}


</script>


<style>
.font {
font-size: 1.4rem;
}

.card-1 {
    transform: scale(1.0);
    overflow: visible!important;
    transition-duration: 0.5s;
    width: 450px;
    margin: 10px;
    height: 110px;
    background: aliceblue;
    filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.4));
}

.card-1:hover {
    transform: scale(1.1);
    
    transition-duration: 0.5s;
}
.distance {
    background-color: rgba(94, 91, 91, 1);
    width:37.5%;
    height: 100%;
}
.name {
    width: 75%;
    height: 90%;
    background-color: rgba(151, 197, 185, 1);
}

.content {
    transition: max-height 0.2s ease-out;
    width: 100%;
    position: relative;
    overflow: hidden;
    max-height: 0;
    margin-bottom: 10px;
    background: aliceblue;
}

</style>